import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Row, Col, Typography } from "antd";

function EChartUsersByMonth() {
  const { Title, Paragraph } = Typography;
  const [chartData, setChartData] = useState({
    options: {
      chart: { toolbar: { show: false } },
      colors: ["#fff"],
      plotOptions: {
        bar: {
          columnWidth: "70%",
          borderRadius: 4,
        },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: [
          "Jan",
          "Fév",
          "Mar",
          "Avr",
          "Mai",
          "Juin",
          "Juil",
          "Août",
          "Sep",
          "Oct",
          "Nov",
          "Déc",
        ],
        labels: {
          style: {
            colors: Array(12).fill("#FFFFFF"), // Blanc pour tous les mois
            fontSize: "12px",
            fontWeight: "bold",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (val) => Math.round(val),
          style: {
            colors: Array(12).fill("#FFFFFF"), // Blanc pour tous les mois
            fontSize: "12px",
            fontWeight: "bold",
          },
        },
      },
      tooltip: {
        y: { formatter: (val) => `${val} utilisateurs` },
      },
    },
    series: [{ name: "Utilisateurs", data: Array(12).fill(0) }],
  });

  const [totalUsers, setTotalUsers] = useState(0);

  useEffect(() => {
    const fetchUsersByMonth = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users`);
        if (!res.ok) throw new Error("Erreur API");
        const users = await res.json();

        // Compter les utilisateurs par mois
        const counts = Array(12).fill(0);
        users.forEach((user) => {
          const monthIndex = new Date(user.createdAt).getMonth(); // 0 = Janvier
          counts[monthIndex]++;
        });

        setTotalUsers(users.length);

        setChartData((prev) => ({
          ...prev,
          series: [{ name: "Utilisateurs", data: counts }],
        }));
      } catch (err) {
        console.error("Erreur récupération users par mois:", err);
      }
    };

    fetchUsersByMonth();
  }, []);

  return (
    <>
      <div id="chart">
        <ReactApexChart
          className="bar-chart"
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={220}
        />
      </div>

      <div className="chart-vistior">
        <Title level={5}>Utilisateurs par mois</Title>
        <Paragraph className="lastweek">
          Total actuel : <span className="bnb2">{totalUsers}</span> utilisateurs
        </Paragraph>
        <Row gutter>
          {chartData.series[0].data.map((count, index) => (
            <Col xs={6} xl={6} sm={6} md={6} key={index}>
              <div className="chart-visitor-count">
                <Title level={4}>{count}</Title>
                <span>{chartData.options.xaxis.categories[index]}</span>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default EChartUsersByMonth;
